export { SoleTraderTile, type SoleTraderTileProps } from './SoleTraderTile';
